import React, {useState, useCallback, useEffect} from 'react';
import {setSampleDragging} from "actions/index.js";
import { connect } from "react-redux";
import Colors from 'components/Colors.js';
import {MIX} from 'constants/instrument-mix-modes.js';

const colors = new Colors();

function SampleThumb(props) {
    let {sample} = props;
    if (sample === undefined) {
        return (<div></div>);
    }

    let style = {
        backgroundColor: colors.getColorForHash(sample.getId())
    };

    let thumbnail = sample.getThumbnail();

    const onDragOver = (e) => {
        e.stopPropagation();
    };

    const onDragStart = useCallback((e) => {
        props.setSampleDragging(sample);
    }, [sample]);

    let className = "key-info";
    if (props.isOn) {
        className += " on";
    }
    if (thumbnail) {
        return (
            <img
              draggable={true}
              onDragStart={onDragStart}
              onDragOver={onDragOver}
              onClick={props.onClickSampler}
              className={className} src={thumbnail}/>
        );
    }

    return (
        <div
          draggable={true}
          onDragStart={onDragStart}
          onDragOver={onDragOver}
          onClick={props.onClickSampler}
          style={style} className={className}>
          {props.i+1}
        </div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        isOn: props.sampler.on || props.instrument.mixMode === MIX ||
            props.isSelectedSampler,
    }
};
 
const mapDispatchToProps = (dispatch, props) => {
    return {
        setSampleDragging: (sample) => dispatch(setSampleDragging(sample)),
    };
};
 
export default connect(mapStateToProps, mapDispatchToProps)(SampleThumb);




